//libs
import React, { memo } from 'react';

//global components
import RouteChunkRenderer from 'shared/components/RouteChunkRenderer';
import ChunkFallback from 'shared/components/ChunkFallback';

//components
import RedirectToHomePage from 'shared/components/RedirectToHomePage';
import RewardsPage from 'shared/components/FootlockerRewards/components/RewardsPage';

// hooks
import { useRemoteConfig } from 'shared/store/remoteConfigs/hooks';

function RewardsPageRenderer() {
  const isRewardsPageEnabled = useRemoteConfig('rewardsPageEnabled') || false;

  return (
    <RouteChunkRenderer
      mobileComponent={
        isRewardsPageEnabled ? <RewardsPage fallback={<ChunkFallback />} /> : <RedirectToHomePage />
      }
      desktopComponent={<RedirectToHomePage />}
    />
  );
}

export default memo(RewardsPageRenderer);
